/**
 * AiTextClient — 클라이언트 AI 텍스트 생성 (서버 경유).
 *
 * 왜 서버를 거치는가 (2026-08-10 비용 사고):
 *   예전에는 브라우저가 Firebase AI Logic(firebasevertexai)을 직접 호출했다. 그런데
 *   Firebase 클라이언트 설정(apiKey·projectId·appId)은 설계상 웹 번들에 공개되므로,
 *   App Check 가 적용돼 있지 않으면 **그 설정만 가진 외부인이 우리 프로젝트 명의로
 *   모델을 호출**할 수 있다. 실제로 외부에서 이미지 생성 모델을 밤새 돌려 4일간
 *   1.4만엔이 청구됐다(운영 → 개발로 옮겨가며 계속).
 *
 *   서버 경유로 바꾸면 클라이언트가 firebaseml/firebasevertexai 를 아예 쓰지 않으므로
 *   그 API 를 강제 적용하거나 비활성화해도 우리 기능은 영향이 없다. 네이티브(iOS/
 *   Android)에 App Check 플러그인을 넣지 않아도 웹·모바일이 똑같이 동작하는 것도
 *   이 방식의 이점이다.
 *
 * 계약 유지: 기존 호출부는 `getModel().generateContent(prompt)` → `result.response.text()`
 * 형태였다. 그 모양을 그대로 흉내 내 호출부(8곳)를 손대지 않는다.
 */
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

const FB_REGION = 'asia-northeast1';
/** 서버가 화이트리스트로 재검증한다 — 여기 값은 요청일 뿐 최종 권위가 아니다 */
export const AI_TEXT_MODEL = 'gemini-2.5-flash-lite';

interface AiTextResult {
  response: { text: () => string };
}

/**
 * 서버 프록시 모델 핸들. 예전 Firebase AI Logic 모델 객체와 같은 표면을 제공한다.
 * @param model 화이트리스트 모델명 (미지정 시 서버 기본값)
 */
export function getAiTextModel(model: string = AI_TEXT_MODEL, temperature?: number) {
  return {
    async generateContent(prompt: string): Promise<AiTextResult> {
      const fns = getFunctions(getApp(), FB_REGION);
      // 회의록 전문 분석은 수십 초가 걸린다 — 기본 70s 로는 서버 성공을 클라가 실패로 오판
      const call = httpsCallable<
        { prompt: string; model?: string; temperature?: number }, { text: string }
      >(fns, 'aiGenerateText', { timeout: 120_000 });
      const res = await call({ prompt, model, ...(temperature !== undefined ? { temperature } : {}) });
      const text = res.data?.text ?? '';
      return { response: { text: () => text } };
    },
  };
}
